import { memo } from "react";
import { Div, useTheme } from "react-better-html";

type SectionProps = {
   title?: string;
   description?: string;
   backgroundColor?: React.CSSProperties["backgroundColor"];
   border?: React.CSSProperties["border"];
   disabled?: boolean;
   children?: React.ReactNode;
};

function Section({ title, description, backgroundColor, border = "none", disabled, children }: SectionProps) {
   const theme = useTheme();

   return (
      <Div.box
         title={title}
         titleAs="h3"
         description={description}
         border={border}
         backgroundColor={backgroundColor ?? theme.colors.backgroundContent}
         borderRadius={theme.styles.borderRadius * 2}
         padding={theme.styles.space}
         cursor={disabled ? "not-allowed" : undefined}
         opacity={disabled ? 0.7 : undefined}
         pointerEvents={disabled ? "none" : undefined}
      >
         {children}
      </Div.box>
   );
}

export default memo(Section);
